import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogAction,
	AlertDialogCancel,
} from "@/components/primitives";
import { buttonVariants } from "@/components/ui/button";

interface PrintAnalysisDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onYes: () => void;
	onNo: () => void;
}

export function PrintAnalysisDialog({
	open,
	onOpenChange,
	onYes,
	onNo,
}: PrintAnalysisDialogProps) {
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Print Options</AlertDialogTitle>
					<AlertDialogDescription>
						A reflection analysis is available. Would you like to combine the
						Reflection report and analysis in your print?
						<br />
						<br />
						You can print the report only, the analysis only, or both combined.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={onNo}>Report Only</AlertDialogCancel>
					<AlertDialogAction
						onClick={onYes}
						className={buttonVariants({ variant: "default" })}
					>
						Combine Both
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
